import { ActionSettings } from '@robotsnacks/icons';
import { noop } from 'lodash';
import React, { Component } from 'react';

import {
  ToolbarFlyout,
  WithStyles,
  createStyles,
  withStyles,
} from '@robotsnacks/ui';

const styles = createStyles<'root'>(theme => ({
  root: {
    fontSize: 13,
    margin: '0.5rem',
    padding: 2,
    whiteSpace: 'nowrap',
    textAlign: 'center',
    '& strong': {
      fontWeight: 700,
    },
  },
}));

export interface CardOptionsFlyoutProps {
  showSponsor?: boolean;
  onShowSponsorChange?: (showSponsor: boolean) => void;
}

type Props = WithStyles<CardOptionsFlyoutProps, typeof styles> &
  typeof defaultProps;

type State = {
  in?: boolean;
};

const defaultProps = Object.freeze({
  onDeleteClick: noop,
});

const initialState = Object.freeze({
  in: false,
});

class CardOptionsFlyout extends Component<Props, State> {
  static defaultProps = defaultProps;
  state = initialState;

  render() {
    const { classes, showSponsor, onShowSponsorChange } = this.props;
    const flyout = (
      <div className={classes.root}>
        <label>
          <input
            onChange={e =>
              onShowSponsorChange
                ? onShowSponsorChange(e.target.checked as any)
                : null
            }
            type="checkbox"
            checked={showSponsor}
          />{' '}
          Show Card Sponsor
        </label>
      </div>
    );

    return (
      <ToolbarFlyout
        flyout={flyout}
        in={this.state.in}
        onFocus={this._handleFocus}
        onBlur={this._handleBlur}
      >
        <ActionSettings />
      </ToolbarFlyout>
    );
  }

  private _handleFocus = () => {
    this.setState({ in: true });
  };

  private _handleBlur = () => {
    this.setState({ in: false });
  };
}

export default withStyles(styles)(CardOptionsFlyout);
